import {useState} from "react";
import {setMaterials} from "../disposalSlice";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../redux/rootReducer";
import {isEmpty} from "lodash";
import {Material} from "../../../API";

function useMaterials() {

    const dispatch = useDispatch();

    const {currentDisposal} = useSelector((state: RootState) => state.disposal);

    const [_materials, _setMaterials] = useState<Material[]>(
        currentDisposal.materials ? currentDisposal.materials as Material[] : []
    );

    const toggleMaterial = (mt: Material) => {
        if (_materials.includes(mt)) {
            _setMaterials(prevState => prevState.filter(item => item !== mt));
        } else {
            _setMaterials(prevState => [...prevState, mt]);
        }
    };

    const materialIsEmpty = (): boolean => isEmpty(_materials);

    const materialPresent = (cmt: Material): boolean => _materials && _materials.includes(cmt);

    const materialsToStore = () => dispatch(setMaterials(_materials));

    return {
        toggleMaterial,
        materialPresent,
        materialsToStore,
        materialIsEmpty
    };
}

export default useMaterials;
